import type { ApiResponse, FetchHeaders, UnleashToggles } from '@/interfaces';
import { fetchFromApi } from '@/utils/fetch/resolveFetch';
import type { ExtraHotelDataRecord } from '@/server/integration/extraHotelDataResponseTypes';

const listToQueryParam = (name: string, list: readonly string[]) => list.map((element) => `${name}=${element}`);

const extraHotelDataProviders = (unleash?: UnleashToggles): readonly string[] => (unleash.thonDirectBooking ? ['thon'] : []);

export const extraHotelDataQueryParams = (hotels: readonly string[], unleash?: UnleashToggles) =>
    listToQueryParam('hotelFilename', hotels)
        .concat(listToQueryParam('provider', extraHotelDataProviders(unleash)))
        .join('&');

export const getExtraHotelData = async (
    hotels: readonly string[],
    unleash?: UnleashToggles,
    headers?: FetchHeaders,
): Promise<ApiResponse<ExtraHotelDataRecord>> =>
    fetchFromApi(`/api/extraHotelData/?${extraHotelDataQueryParams(hotels, unleash)}`, headers);
